<form [formGroup]="contactForm">
    <div class="formgrid grid">
        <div class="field col-12 flex justify-content-between align-items-center"> 
            <div class="mt-2">
                <button pButton pRipple type="button" [label]="isEditMode ? 'Update' : 'Save'" class="p-button-sm "
                    icon="pi pi-save"
                    (click)="!isEditMode ? createContact(contactForm.value) : updateContact(contactForm.value)">
                </button>
                <p-button label="Discard" class="p-button-outlined ml-2" icon="pi pi-times" severity="danger"
                    size="small" (click)="cancel()"></p-button>
            </div>

            <div>
                <label class="block label-required" style="font-weight: bold;">Required Field</label>
            </div>
        </div>
    </div>
    <div class="formgrid grid">
        <div class="field col-12 flex">
            <div *ngFor="let option of radioOptions" class="flex align-items-center">
                <p-radioButton [value]="option" [inputId]="'option_' + option.toLowerCase()" formControlName="type"
                    (click)="onTypeSelect(option)"></p-radioButton>
                <label [for]="'option_' + option.toLowerCase()" class="m-2" style="margin-right: 12px;">{{ option
                    }}</label>
            </div>
        </div>
        <small *ngIf="submitted && formControls.type.errors" id="name-error" class="text-red-500 field col-12">Required
            field.</small>
    </div>


    <p-divider></p-divider>

    <div class="grid">
        <div class="col">
            <div class="flex align-items-end gap-2">
                <div class="field text-left" style="margin-bottom: 0.5rem !important;">
                    <label for="prefix">Prefix</label>
                    <div>
                        <p-dropdown formControlName="prefix" [options]="prefixOptions" styleClass="w-full"
                            placeholder="Prefix" onchange="prefix"
                            [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.prefix.errors }">
                        </p-dropdown>
                    </div>
                </div>

                <div class="w-9">
                    <label for="contactName" class="label-required display font-bold">Contact Name</label>
                    <input pInputText placeholder="Name" class="w-full p-inputtext-sm" formControlName="contactName"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.contactName.errors}" />
                    <small *ngIf="submitted && formControls.contactName.errors" class="text-red-500"
                        style="text-align: left !important;"></small> 
                </div>

            </div>

            <div class="field text-left mt-3">
                <label for="gender">Gender</label>
                <p-dropdown formControlName="gender" [options]="gender" placeholder="Select Gender" styleClass="w-full"
                    [ngClass]="{ 'ng-invalid ng-dirty': submitted && formControls.gender.errors}">
                </p-dropdown>

            </div>

            <div class="field text-left">
                <label for="dob">Date of Birth</label>
                <p-calendar formControlName="dob" [showIcon]="true" [maxDate]="today" dateFormat="dd/mm/yy"
                    styleClass="w-full" placeholder="Select Date"
                    [ngClass]="{ 'ng-invalid ng-dirty': submitted && formControls.dob.errors }">
                </p-calendar>
            </div>


            <div class="field text-left" formGroupName="address">
                <label class="label-required">Address</label>
                <input pInputText placeholder="Street Address" class="w-full p-inputtext-sm"
                    formControlName="addressLine1"
                    [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.address.controls.addressLine1.errors}" />
                <small *ngIf="submitted && formControls.address.controls.addressLine1.errors"
                    class="text-red-500"></small>

                <input pInputText placeholder="Street Address 2" class="w-full p-inputtext-sm mt-1"
                    formControlName="addressLine2" />

                <div class="flex mt-1">
                    <div>
                        <input pInputText placeholder="City" class="w-full p-inputtext-sm" formControlName="city"
                            [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.address.controls.city.errors}" />
                        <small *ngIf="submitted && formControls.address.controls.city.errors"
                            class="text-red-500"></small>
                    </div>

                    <div class="ml-1">
                        <p-autoComplete [dropdown]="true" placeholder="State" (onBlur)="checkState()"
                            (onSelect)="setState($event)" formControlName="state" [suggestions]="filterStates"
                            (completeMethod)="filterState($event)" field="stateName"
                            [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.address.controls.state.errors}">
                        </p-autoComplete>
                        <small *ngIf="submitted && formControls.address.controls.state.errors"
                            class="text-red-500"></small>
                    </div>

                    <div class="ml-1">
                        <input pInputText placeholder="Zip" class="w-full p-inputtext-sm" formControlName="zip"
                            [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.address.controls.zip.errors}" />
                        <small *ngIf="submitted && formControls.address.controls.zip.errors"
                            class="text-red-500"></small>
                        <small
                            *ngIf="formControls.address.controls.zip.value && formControls.address.controls.zip.value.length !== 6"
                            class="text-red-500">Zip code must be exactly 6 digits.</small>
                    </div>

                </div>
                <input pInputText placeholder="Country" class="w-full p-inputtext-sm mt-1" formControlName="country"
                    [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.address.controls.country.errors}" />
                <small *ngIf="submitted && formControls.address.controls.country.errors" class="text-red-500"></small>
            </div>
        </div>



        <div class="col">

            <div class="field text-left">
                <label for="job_Title">Job Title</label>
                <input pInputText placeholder="Job Title" class="w-full p-inputtext-sm" formControlName="job_Title" />
            </div>

            <div class="field text-left">
                <label for="email" class="label-required">Email</label>
                <input pInputText placeholder="Email" class="w-full p-inputtext-sm" formControlName="email"
                    [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.email.errors}" />
                <small *ngIf="submitted && formControls.email.errors" class="text-red-500"></small>
            </div>

            <div class="field text-left mt-3">
                <label for="work_Email">Work Email</label>
                <input pInputText placeholder="Work Email" class="w-full p-inputtext-sm" formControlName="work_Email" />
            </div>

            <div class="field text-left">
                <label for="phone">Phone</label>
                <input pInputText placeholder="Phone" class="w-full p-inputtext-sm" formControlName="phone"
                    [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.phone.errors}" />
            </div>

            <div class="field text-left">
                <label for="mobile">Mobile</label>
                <input pInputText placeholder="Mobile" class="w-full p-inputtext-sm" formControlName="mobile"
                    [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.mobile.errors}" />
                <small *ngIf="submitted && formControls.mobile.errors?.['pattern']" class="text-red-500">Mobile must be
                    10
                    digits.</small>
            </div>
        </div>




        <div class="col">
            <div class="field text-left">
                <label for="website">Website</label>
                <input pInputText placeholder="Website" class="w-full p-inputtext-sm" formControlName="website" />
            </div>

            <div class="field text-left">
                <label for="facebook">Facebook</label>
                <input pInputText placeholder="Facebook" class="w-full p-inputtext-sm" formControlName="facebook" />
            </div>

            <div class="field text-left">
                <label for="twitter">X (Twitter)</label> 
                <input pInputText placeholder="Twitter" class="w-full p-inputtext-sm" formControlName="twitter" />
            </div>

            <div class="field text-left">
                <label for="internalNotes" class="display">Internal Notes</label>
                <textarea rows="2" pInputTextarea formControlName="internalNotes"
                    class="w-full p-inputtext-sm"></textarea>
            </div>
        </div>

    </div>

</form>